// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AudioReferenceNode 样式 */
.AudioReferenceNode-wrapper {
  width: 280px;
}

.AudioReferenceNode-error {
  padding: 8px 12px;
  margin-bottom: 8px;
  background: #fee;
  border: 1px solid #fcc;
  border-radius: 6px;
  font-size: 12px;
  color: #c33;
}

.AudioReferenceNode-preview {
  position: relative;
}

.AudioReferenceNode-player-container {
  padding: 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.AudioReferenceNode-audio {
  width: 100%;
  height: 40px;
  border-radius: 6px;
}

.AudioReferenceNode-clear {
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 6px;
  background: rgba(0, 0, 0, 0.6);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  line-height: 1;
  z-index: 1;
}

.AudioReferenceNode-clear:hover {
  background: rgba(0, 0, 0, 0.8);
}

.AudioReferenceNode-info {
  margin-top: 8px;
}

.AudioReferenceNode-upload-status {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: #f0f4ff;
  border-radius: 6px;
  font-size: 12px;
  color: #667eea;
  margin-bottom: 6px;
}

.AudioReferenceNode-loading-small {
  width: 14px;
  height: 14px;
  border: 2px solid #e0e0e0;
  border-top: 2px solid #667eea;
  border-radius: 50%;
  animation: AudioReferenceNode-spin 1s linear infinite;
}

.AudioReferenceNode-filename {
  font-size: 11px;
  color: #666;
  word-break: break-all;
  padding: 4px 0;
}

.AudioReferenceNode-warning {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 4px;
  font-size: 11px;
  color: #856404;
  margin-top: 4px;
}

.AudioReferenceNode-dropzone {
  border: 2px dashed #ddd;
  border-radius: 8px;
  padding: 32px 16px;
  text-align: center;
  cursor: pointer;
  background: white;
  transition: all 0.2s;
}

.AudioReferenceNode-dropzone:hover {
  border-color: #667eea;
  background: #f9faff;
}

.AudioReferenceNode-dropzone-active {
  border-color: #667eea;
  background: #f0f4ff;
}

.AudioReferenceNode-dropzone-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.AudioReferenceNode-icon {
  color: #999;
}

.AudioReferenceNode-text {
  font-size: 13px;
  color: #666;
}

.AudioReferenceNode-hint {
  font-size: 11px;
  color: #999;
}

.AudioReferenceNode-loading {
  width: 32px;
  height: 32px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #667eea;
  border-radius: 50%;
  animation: AudioReferenceNode-spin 1s linear infinite;
}

@keyframes AudioReferenceNode-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}


`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/AudioReferenceNode.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC","sourcesContent":["/* AudioReferenceNode 样式 */\n.AudioReferenceNode-wrapper {\n  width: 280px;\n}\n\n.AudioReferenceNode-error {\n  padding: 8px 12px;\n  margin-bottom: 8px;\n  background: #fee;\n  border: 1px solid #fcc;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #c33;\n}\n\n.AudioReferenceNode-preview {\n  position: relative;\n}\n\n.AudioReferenceNode-player-container {\n  padding: 16px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.AudioReferenceNode-audio {\n  width: 100%;\n  height: 40px;\n  border-radius: 6px;\n}\n\n.AudioReferenceNode-clear {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  padding: 6px;\n  background: rgba(0, 0, 0, 0.6);\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 20px;\n  line-height: 1;\n  z-index: 1;\n}\n\n.AudioReferenceNode-clear:hover {\n  background: rgba(0, 0, 0, 0.8);\n}\n\n.AudioReferenceNode-info {\n  margin-top: 8px;\n}\n\n.AudioReferenceNode-upload-status {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  background: #f0f4ff;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #667eea;\n  margin-bottom: 6px;\n}\n\n.AudioReferenceNode-loading-small {\n  width: 14px;\n  height: 14px;\n  border: 2px solid #e0e0e0;\n  border-top: 2px solid #667eea;\n  border-radius: 50%;\n  animation: AudioReferenceNode-spin 1s linear infinite;\n}\n\n.AudioReferenceNode-filename {\n  font-size: 11px;\n  color: #666;\n  word-break: break-all;\n  padding: 4px 0;\n}\n\n.AudioReferenceNode-warning {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  background: #fff3cd;\n  border: 1px solid #ffc107;\n  border-radius: 4px;\n  font-size: 11px;\n  color: #856404;\n  margin-top: 4px;\n}\n\n.AudioReferenceNode-dropzone {\n  border: 2px dashed #ddd;\n  border-radius: 8px;\n  padding: 32px 16px;\n  text-align: center;\n  cursor: pointer;\n  background: white;\n  transition: all 0.2s;\n}\n\n.AudioReferenceNode-dropzone:hover {\n  border-color: #667eea;\n  background: #f9faff;\n}\n\n.AudioReferenceNode-dropzone-active {\n  border-color: #667eea;\n  background: #f0f4ff;\n}\n\n.AudioReferenceNode-dropzone-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.AudioReferenceNode-icon {\n  color: #999;\n}\n\n.AudioReferenceNode-text {\n  font-size: 13px;\n  color: #666;\n}\n\n.AudioReferenceNode-hint {\n  font-size: 11px;\n  color: #999;\n}\n\n.AudioReferenceNode-loading {\n  width: 32px;\n  height: 32px;\n  border: 3px solid #f3f3f3;\n  border-top: 3px solid #667eea;\n  border-radius: 50%;\n  animation: AudioReferenceNode-spin 1s linear infinite;\n}\n\n@keyframes AudioReferenceNode-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
